import React, { Suspense, lazy } from "react";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";

import Loader from "./Util/Loader/Loader";
// import Error from "./Util/Error/Error";
import PageMiss from "./404/404";

import "./App.css";
import "./buttons.css";
import "./card.css";
import "./Util/Notifications.css";
import { requestForToken, NotificationService } from "./Util/firebase";

const Login = lazy(() => import(/* webpackChunkName: "login" */ "./Login/Login"));
const Dashboard = lazy(() => import(/* webpackChunkName: "Dashboard" */ "./Dashboard/Dashboard"));
const Users = lazy(() => import(/* webpackChunkName: "Users" */ "./Users/Users"));
const Projects = lazy(() => import(/* webpackChunkName: "Projects" */ "./Projects/Projects"));
const Tasks = lazy(() => import(/* webpackChunkName: "Tasks" */ "./Tasks/Tasks"));
const AllTasks = lazy(() => import(/* webpackChunkName: "AllTasks" */ "./AllTasks/AllTasks"));
const UserPermissions = lazy(() => import(/* webpackChunkName: "UserPermission" */ "./UserPermissions/UserPermissions"));
const ForgotPassword = lazy(() => import(/* webpackChunkName: "ForgotPassword" */ "./ForgotPassword/ForgotPassword"));
const ResetPassword = lazy(() => import(/* webpackChunkName: "ResetPassword" */ "./ResetPassword/ResetPassword"));
const TeamDuration = lazy(() => import(/* webpackChunkName: "TeamDuration" */ "./TeamDuration/TeamDuration"));
const Tags = lazy(() => import(/* webpackChunkName: "Tags" */ "./Tags/Tags"));
const Tickets = lazy(() => import(/* webpackChunkName: "Tickets" */ "./Tickets/Tickets"));
const TaskDetail = lazy(() => import(/* webpackChunkName: "TaskDetail" */ "./Tasks/TaskDetail/TaskDetail"));
const Prospect = lazy(() => import(/* webpackChunkName: "Prospect" */ "./Prospect/Prospect"));
const Subscription = lazy(() => import(/* webpackChunkName: "Subscription" */ "./Subscription/Subscription"));
const Invoices = lazy(() => import(/* webpackChunkName: "Invoices" */ "./Invoices/Invoices"));
const FileUploadInDrive = lazy(() => import(/* webpackChunkName: "FileUploadInDrive" */ "./FileUploadInDrive/FileUploadInDrive"));
const Verified = lazy(() => import(/* webpackChunkName: "Verified" */ "./FileUploadInDrive/Verified"));
const LogPastTasks = lazy(() => import(/* webpackChunkName: "LogPastTasks" */ "./LogPastTasks/LogPastTasks"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#181818",
    },
    secondary: {
      main: "#e31e32",
    },
  },
});

//
// GTag measurement ID

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPermissionBanner: false,
    };
    this.customHistory = createBrowserHistory();
  }

  componentDidMount() {
    this.initializeNotifications();
    //   setTimeout(() => {
    //    NotificationService.showTestNotification();
    //   }, 1000);
  }

  initializeNotifications = async () => {
    if (!NotificationService.isSupported) {
      console.log("Notifications not supported in this browser");
      return;
    }

    if (NotificationService.hasPermission()) {
      await requestForToken();
    } else {
      this.setState({ showPermissionBanner: true });
    }
  };

  handleNotificationPermission = async (grant) => {
    this.setState({ showPermissionBanner: false });

    if (grant) {
      await requestForToken();
    }
  };

  renderPermissionBanner = () => {
    if (!this.state.showPermissionBanner) return null;
  };

  render = () => {
    return (
      <ThemeProvider theme={theme}>
        {this.renderPermissionBanner()}
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <div className="loader-container">
                <Loader />
              </div>
            }
          >
            <Switch>
              <Route exact path="/" component={Login} />
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/users" component={Users} />
              <Route path="/projects" component={Projects} />
              <Route path="/project-task/:projectId" component={Tasks} />
              <Route path="/task/:taskId" component={TaskDetail} />
              <Route path="/tasks" component={Tasks} />
              <Route path="/team-tasks" component={AllTasks} />
              <Route path="/team-report" component={TeamDuration} />
              <Route path="/user-permissions" component={UserPermissions} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route path="/reset-password/:token" component={ResetPassword} />
              <Route path="/tags" component={Tags} />
              <Route path="/tickets" component={Tickets} />
              <Route path="/prospects" component={Prospect} />
              <Route path="/subscription" component={Subscription} />
              <Route path="/invoices/:sub_plan" component={Invoices} />
              <Route exact path="/file-upload-drive" component={FileUploadInDrive} />
              <Route exact path="/file-upload-drive/:projectID" component={FileUploadInDrive} />
              <Route path="/verified" component={Verified} />
              <Route path="/log-past-tasks" component={LogPastTasks} />

              <Route component={PageMiss} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  };
}

export default App;
